var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, makeObservable } from 'mobx';
import { Cycle } from '../../cycle/Cycle';
export class TrayCycles {
    parent;
    // const setting = (;
    // readonly answersPerCycle: number = 21;
    get pensumPerCycle() {
        return (this.app.user && this.app.user.userStore.numberOfQuestionsPerCycle) || 20;
    }
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get tray() {
        return this.parent;
    }
    get app() {
        return this.tray.app;
    }
    get numberOfAnswersToCut() {
        return this.app.tray.trayLine.positionOfFrontalAnswer + this.tray.funnel.funnelIncoming.numberOfIncomingAnswers;
    }
    get numberOfChunks() {
        return Math.max(1, Math.ceil(this.numberOfAnswersToCut / this.pensumPerCycle));
    }
    get allCycles() {
        return [...Array(this.numberOfChunks).keys()].map(cycleIndex => new Cycle(this.app, cycleIndex)); // => [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]
    }
    get frontalCycleIndex() {
        return Math.ceil(Math.max(1, this.app.tray.trayAnswers.answersPosed.length) / this.pensumPerCycle) - 1;
    }
    get frontalCycle() {
        return this.allCycles[this.frontalCycleIndex];
    }
    get areCyclesAvailable() {
        return (this.app.topic.topicMicroQuestions.microQuestionsQuery.isAvailable &&
            this.app.history.historyDbMicroAnswers.microAnswersQuery.isAvailable);
    }
}
__decorate([
    computed
], TrayCycles.prototype, "numberOfAnswersToCut", null);
__decorate([
    computed
], TrayCycles.prototype, "numberOfChunks", null);
